import {useInstance} from "../../lib/mate/mate-utils";
import {mentionStyle} from "./markdown.css";

const CardMention = ({userId}) => {
  const user = useInstance("user", userId);
  return <span className={mentionStyle}>@{user ? user.name : "someone"}</span>;
};

export default CardMention;
